import type * as React from "react";

import { cn } from "../utils/mergeClassNames";

/**
 * When `style.background` is set, it replaces the default glass fill (e.g. layered
 * `padding-box` / `border-box` backgrounds). Callers must include backdrop filters if needed.
 */
function GlassCard({ className, style, ...props }: React.ComponentProps<"div">) {
  const hasCustomBackground =
    style != null &&
    typeof style === "object" &&
    "background" in style &&
    style.background !== undefined &&
    style.background !== "";

  return (
    <div
      data-slot="glass-card"
      className={cn("rounded-xl border border-white/20 shadow-sm", className)}
      style={
        hasCustomBackground
          ? {
              backdropFilter: "var(--glass-backdrop-filter)",
              WebkitBackdropFilter: "var(--glass-backdrop-filter)",
              ...style,
            }
          : {
              ...style,
              background: "var(--glass-background)",
              backdropFilter: "var(--glass-backdrop-filter)",
              WebkitBackdropFilter: "var(--glass-backdrop-filter)",
            }
      }
      {...props}
    />
  );
}

export { GlassCard };
